import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "io-mfe-ig-procedure-column full-height min-height flex column" }
const _hoisted_2 = { class: "ellipsis full-width" }

import { ProcedureColumnItem } from 'stores/search-store';

export type IsItemSelectedFunction = (item: ProcedureColumnItem) => boolean;

interface Props {
  title?: string;
  items?: ProcedureColumnItem[];
  active?: boolean,
  isItemSelected?: IsItemSelectedFunction
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ProcedureColumn',
  props: {
    title: { default: '' },
    items: {},
    active: { type: Boolean, default: false },
    isItemSelected: {}
  },
  emits: ["optionClicked"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function optionClicked(option: ProcedureColumnItem) {
  emit('optionClicked', option);
}


return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["io-mfe-ig-procedure-column-title", {'io-mfe-ig-procedure-column-active': props.active}])
    }, [
      _createTextVNode(_toDisplayString(props.title) + " ", 1),
      _createElementVNode("span", null, _toDisplayString(props.active ? '(select)' : ''), 1)
    ], 2),
    _createVNode(_component_q_list, {
      bordered: "",
      class: "full-height min-height"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((props.items || []), (item) => {
          return (_openBlock(), _createBlock(_component_q_item, {
            key: item.char,
            class: "io-mfe-ig-procedure-column-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                unelevated: "",
                onClick: ($event: any) => (optionClicked(item)),
                class: _normalizeClass({'io-mfe-ig-procedure-column-selected': props.isItemSelected && props.isItemSelected(item)})
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(item.char) + "     " + _toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "class"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})